// Production-ready logging utility
// Only logs errors in production, all logs in development

const isDevelopment = import.meta.env.MODE === 'development';
const isProduction = import.meta.env.MODE === 'production';

export class Logger {
  static log(message: string, data?: any): void {
    if (isDevelopment) {
      console.log(message, data);
    }
  }

  static info(message: string, data?: any): void {
    if (isDevelopment) {
      console.info(message, data);
    }
  }

  static warn(message: string, data?: any): void {
    if (isDevelopment) {
      console.warn(message, data);
    }
    // In production, warnings could be sent to monitoring service
  }

  static error(message: string, error?: any): void {
    // Always log errors in both dev and production
    console.error(message, error);
    
    // In production, send to error tracking service
    if (isProduction && error) {
      // TODO: Implement error tracking service integration
      // e.g., Sentry, LogRocket, or Firebase Analytics
    }
  }

  static debug(message: string, data?: any): void {
    if (isDevelopment) {
      console.debug(message, data);
    }
  }
}

// Export convenience functions
export const log = Logger.log;
export const logInfo = Logger.info;
export const logWarn = Logger.warn;
export const logError = Logger.error;
export const logDebug = Logger.debug;